export default __webpack_public_path__ + "static/media/thumbnail.75e94a51.png";